module.exports = __webpack_public_path__ + "images/patterns/light/BrickDiagonal.ffdb9953ca2f8b930b75.svg";